import { Vue, Component } from "vue-property-decorator";
import State from "@/state";

@Component({})
export default class Response extends Vue {
  response(state: State) {
    this.$emit("response", state);
  }
}
